import React, { useEffect, useState } from "react";
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import RegisterHeader from "../../../components/register-header/RegisterHeader";
import CustomModal from "../../../components/modal/CustomModal";
import { ERROR, NO_RECORDS_FOUND, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";
import AHMIS, { API_URL } from "../../../api/api";
import AddAlertMessage from "../../../components/alert/Alert";
import { AppMisc } from "../../../misc/appMisc";

const Sessions = () => {
  const [sessions, setSessions] = useState([]);
  const [activities, setActivities] = useState([]);
  const [showActivitiesModal, setShowActivitiesModal] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);

  const getSessions = () => {
    AHMIS.get(API_URL.auditSessions)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setSessions(jsondata.objectList || []);
        }
      }).catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  useEffect(() => {
    getSessions();
  }, []);

  const openActivities = (session) => {
    setSelectedSession(session);
    AHMIS.get(API_URL.auditActivities + "/" + session.id)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setActivities(jsondata.objectList || []);
          setShowActivitiesModal(true);
        }
      }).catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const closeActivitiesModal = () => {
    setShowActivitiesModal(false);
    setSelectedSession(null);
    setActivities([]);
  }

  const formatTime = (millis) => {
    if (!millis) return "-";
    return AppMisc.getDateLabelFromMillisecond(millis);
  }

  const getDuration = (loginTime, logoutTime) => {
    if (!loginTime) return "-";
    if (!logoutTime) return "Active";
    const diffMs = logoutTime - loginTime;
    const totalSeconds = Math.floor(diffMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`;
    if (minutes > 0) return `${minutes}m ${seconds}s`;
    return `${seconds}s`;
  }

  return (
    <>
      <RegisterHeader registerTitle="Sessions" hideButton hideDateFilter showSearchField={false} />
      <Box mt={2}>
        <TableContainer>
          <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="sessions table">
            <TableHead classes={{ root: "align-center" }}>
              <TableRow>
                <TableCell>क्र.सं</TableCell>
                <TableCell>User Email</TableCell>
                <TableCell>Login Time</TableCell>
                <TableCell>Logout Time</TableCell>
                <TableCell>Duration</TableCell>
                <TableCell>IP Address</TableCell>
                <TableCell>Browser</TableCell>
                <TableCell>Device</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Activities</TableCell>
              </TableRow>
            </TableHead>
            <TableBody classes={{ root: "align-center" }}>
              {sessions.length > 0 ? (
                sessions.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.userEmail || "-"}</TableCell>
                    <TableCell>{formatTime(row.loginTime)}</TableCell>
                    <TableCell>{formatTime(row.logoutTime)}</TableCell>
                    <TableCell>{getDuration(row.loginTime, row.logoutTime)}</TableCell>
                    <TableCell>{row.ipAddress || "-"}</TableCell>
                    <TableCell>{row.browser || "-"}</TableCell>
                    <TableCell>{row.device || "-"}</TableCell>
                    <TableCell>{row.sessionStatus || "-"}</TableCell>
                    <TableCell>
                      <Tooltip title="View Activities" placement="top" arrow>
                        <IconButton onClick={() => openActivities(row)} size="small">
                          <Visibility fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={10} size="medium">{NO_RECORDS_FOUND}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <CustomModal
        title={selectedSession ? `Activities - ${selectedSession.userEmail}` : "Activities"}
        showModal={showActivitiesModal}
        onModalClose={closeActivitiesModal}
        hideSubmitBtn
        maxWidth="lg"
        fullWidth
      >
        <TableContainer>
          <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="activities table">
            <TableHead classes={{ root: "align-center" }}>
              <TableRow>
                <TableCell>क्र.सं</TableCell>
                <TableCell>Timestamp</TableCell>
                <TableCell>Request URL</TableCell>
                <TableCell>Method</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Operation</TableCell>
                <TableCell>Module</TableCell>
                <TableCell>Execution Time (ms)</TableCell>
                <TableCell>Client IP</TableCell>
              </TableRow>
            </TableHead>
            <TableBody classes={{ root: "align-center" }}>
              {activities.length > 0 ? (
                activities.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{formatTime(row.createdDate)}</TableCell>
                    <TableCell style={{ maxWidth: 300, wordBreak: "break-all" }}>{row.requestUrl || "-"}</TableCell>
                    <TableCell>{row.httpMethod || "-"}</TableCell>
                    <TableCell>{row.responseStatus || "-"}</TableCell>
                    <TableCell>{row.operation || "-"}</TableCell>
                    <TableCell>{row.module || "-"}</TableCell>
                    <TableCell>{row.executionTime ?? "-"}</TableCell>
                    <TableCell>{row.clientIp || "-"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} size="medium">{NO_RECORDS_FOUND}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CustomModal>
    </>
  );
};

export default Sessions;
